import api from "../api/axios";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export interface CreateRegionPayload {
  country: string;
  name: string;
  status: number;
}

export interface UpdateRegionPaylod extends CreateRegionPayload {}

export const REGION_QUERY_KEY = ["regions"];
export const VIEW_REGION_QUERY_KEY = ["view-regions"];

export const regionService = {
  createRegions: async (payload: CreateRegionPayload) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/regions", payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  updateRegion: async (id: number, payload: UpdateRegionPaylod) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(`api/regions/${id}`, payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  toggleStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/regions/${id}/toggle-status`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  getRegionById: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/regions/${id}`, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  getAllRegions: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/regions`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),

  viewAllRegions: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-regions`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
